import { render, staticRenderFns } from "./Terreno.vue?vue&type=template&id=23258682"
import script from "./Terreno.vue?vue&type=script&lang=js"
export * from "./Terreno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports